import { Resource } from "@lagoshny/ngx-hateoas-client";

export class BaseEntity extends Resource {
  id: number;
}
